import React, {useState} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Pressable, Text, View } from 'react-native';
import { SALESPEOPLE_WITH_COUNT, HIDE_SALESPERSON } from './queries';
import { useMutation } from '@apollo/client';
import SubNav from './SubNav';
import { Link } from 'app/src/utils/routing';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import { abbreviations as states} from 'app/src/elements/states';
import Modal from '../../elements/Modal';
import EditSalesperson from './edit';

import {
  SalespeopleContainer
} from './elements';
import { MainContainer, ContentContainer } from '../../elements';

const inputStyle = {
  marginBottom: '10px'
}

const Salespeople = () => {
  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const [clickedSalesperson, setClickedSalesperson] = useState();
  const [showEditSalespersonModal, setShowEditSalespersonModal] = useState(false);
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };
  const [hideSalesperson] = useMutation(
    HIDE_SALESPERSON, { onCompleted: refetch }
  )

  const onHide = (salespersonId) => {
    hideSalesperson({ variables: { id: salespersonId }});
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: 'salesPerson',
      label: 'SalesPerson',
      content: (entry) => entry.entry.vendor ?
        entry.entry.vendor?.name :
        `${entry.entry.user?.firstName} ${entry.entry.user?.lastName}`
    },
    {
      key: 'type',
      label: 'Type',
      content: (entry) => entry.entry.vendor ?
        'Vendor' : 'User'
    },
    {
      key: 'commission',
      label: 'Commission',
      content: (entry) => entry.entry.commission?.name
    },
    {
      key: 'seller',
      label: 'Seller',
      content: (entry) => entry.entry.seller?.name
    },
    // {
    //   key: 'functions',
    //   label: 'Functions',
    //   // width: '15%',
    //   // minViewportWidth: 1000,
    //   content: (entry) => {
    //     return (
    //       <div style={{display: 'inline-flex'}}>
    //         <Pressable
    //           onPress={() => {
    //             setClickedSalesperson(entry.entry);
    //             setShowEditSalespersonModal(true);
    //           }}
    //         >
    //           <Text>Edit</Text>
    //         </Pressable>
    //       </div>
    //     )
    //   }
    // }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px', justifyContent: 'space-between'}}>

        </View>
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <SubNav refetch={refetch} />
      <ContentContainer>
        <DataTable.Gql
          setRefetch={setRefetch}
          query={SALESPEOPLE_WITH_COUNT}
          queryName='salespeopleWithCount'
          columns={columns}
          buttons={buttons}
          lengthMenu={ [10, 25, 50, 'All'] }
          setSettings={setSettings}
          dataUpdated={data => setFilterOptions(data?.salespeopleWithCount)}
          htmlTable
          queryVariables={queryVariables}
        />
        {showEditSalespersonModal &&
        <Modal
          refetch={refetch}
          showModal={showEditSalespersonModal}
          setShowModal={setShowEditSalespersonModal}
          modalType={'Edit Salesperson'}
          objectName={clickedSalesperson.name}
        >
          <EditSalesperson
            setShowModal={setShowEditSalespersonModal}
            refetch={refetch}
            salesperson={clickedSalesperson}
          />
        </Modal>
      }
      </ContentContainer>
    </MainContainer>
  )
}

export default Salespeople;
